import { action } from 'typesafe-actions';
import { USER_AUTHENTICATED } from './constants';

export const userAuthenticated = (kc: Keycloak.KeycloakInstance) => action(USER_AUTHENTICATED, {kc});
